module.exports = __webpack_public_path__ + "8df154f93c95f1212eaef3876a7b5ce6.jpg";